import React from 'react';
import { Category } from '@v2/shared/lib/types';
import TwoStripNavigation from '@v2/shared/Layouts/Full/TwoStripNavigation';

import InfoLinks from './InfoLinks';
import logo from './images/logo.svg';

type Props = {
  categories?: Category[];
};

/**
 * Ported from `domain-overrides/magzoom.com/layouts/full/header.html`.
 *
 * MagSpot's header with one addition, which is why both draw TwoStripNavigation: the
 * About/FAQ/Contact links sit beside the account ones on a wide screen, separated by the
 * dash the legacy template draws, and move above them in the panel on a phone. Handing
 * them over is also what pushes the account links from sm to md in the header, since
 * they now have something to make room for.
 */
export default function Navigation({ categories }: Props) {
  return (
    <TwoStripNavigation
      categories={categories}
      searchId="magzoom-search"
      logo={{ src: logo, width: 156, height: 33, className: 'w-[156px] h-[33px] block' }}
      extraLinks={<InfoLinks />}
    />
  );
}
